import { useState } from 'react';

import { useEmbed } from './useEmbed';
import { OnboardingPage } from '../features/onboarding/OnboardingPage';
import { InvoicesPage } from '../features/invoices/InvoicesPage';

type Tab = 'invoices' | 'onboarding';

export function App() {
  const embed = useEmbed();
  const [tab, setTab] = useState<Tab>('invoices');

  if (!embed.ready) {
    return (
      <div className="app">
        <div className="center">Esperando sesión del sistema host…</div>
      </div>
    );
  }

  return (
    <div className="app">
      <div className="tabs">
        <button className={`tab ${tab === 'invoices' ? 'active' : ''}`} onClick={() => setTab('invoices')}>
          Comprobantes
        </button>
        <button className={`tab ${tab === 'onboarding' ? 'active' : ''}`} onClick={() => setTab('onboarding')}>
          Onboarding ARCA
        </button>
      </div>

      {tab === 'invoices' ? <InvoicesPage /> : <OnboardingPage defaultCompanyUrn={embed.company} />}
    </div>
  );
}
